import type { ReactNode } from "react";
import { RoasteryMark } from "./roastery-mark";

/**
 * Centred message used while the session is being established and on fatal auth errors.
 *
 * <p>These are the screens a customer sees when nothing else works, and since US-10.5 they carry the
 * roastery's mark: "your access has ended" is a sentence somebody will read before ringing up, and
 * it should be obvious whom to ring.
 */
export function FullScreenMessage({
  title,
  description,
  action,
  roastery,
  testId,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  roastery?: { name?: string; logoUrl?: string | null };
  testId: string;
}) {
  return (
    <div className="flex h-full items-center justify-center p-8" data-testid={testId}>
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        {roastery?.name || roastery?.logoUrl ? (
          <RoasteryMark
            name={roastery.name}
            logoUrl={roastery.logoUrl}
            className="max-h-12 w-auto max-w-56 object-contain"
            testId="portal-message-roastery"
          />
        ) : null}
        <h1 className="text-lg font-semibold">{title}</h1>
        {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
        {action}
      </div>
    </div>
  );
}
